import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SummaryForm from "../../../../hocs/summaryForm";
import { SummaryTypeNames, SummaryTypes } from "../../../../constants/summary";
import {
  PettyCashAction,
  PettyCashierPettyCashAction
} from "../../../../actions";
import { formatDateInNumbers } from "../../../../lib/normalizeDate";
import {
  ButtonsBox,
  ColoredBox,
  FieldContainer
} from "../../../../hocs/summaryForm/style";
import { isEmpty } from "lodash";
import {
  CUSTODIAN_CHANGE_STATE_MODES,
  CUSTODIAN_CONFIRM_FOR_CHANGE_STATE,
  CustodianImprestStateText,
  FIELDS,
  FINAL_EDITED,
  FINAL_EDITED_SENT,
  PETTY_CASH_CONFIRM_ACCEPT_ACTION,
  STATE_ENUM
} from "../../../../constants/pettycash";
import { PETTY_CASH_PETTY_CASHIER } from "../../../../constants/urls";
import Button from "../../../../components/button";
import { Confirm } from "../../../../components/confirm";
import { CURRENCY, USER_IS_OWNER } from "../../../../constants/storageKeys";
import { REDUCER_NAMES } from "../../../../constants/reducerNames";
import { getFileHandleClick } from "../tools/getFile";
import LogSection from "../../../../hocs/summaryForm/components/logSection";
import BudgetSection from "./components/budgetSection/index";
import {
  CONFIRM_OK_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT,
  REJECT_OR_RETURN_WARNING_TEXT,
  WARNING_SINGLE_BUTTON_TEXT
} from "../../../../constants/otherTexts";
import PrintInfo from "../components/printInfoModal";
import { TabWrapper } from "./style";
import Tab from "../../../../components/tab";
import { PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS } from "../../../../constants/tabs";
import ByDetails from "./transactions/byDetails";
import ByAccountTitles from "./transactions/byAccountTitles";
import { TYPE } from "../../../../constants/filters";
import makeSafe from "../../../../lib/makeSafeToUseInDangerousInnerHtml";
import { REASON } from "../../../../constants/reason";
import ReasonModal from "../../../../projectSpecificComponents/reasonModal";

const START_DATE = FIELDS.START_DATE.name;
const END_DATE = FIELDS.END_DATE.name;
const DESCRIPTION = FIELDS.DESCRIPTION.name;

const PanesArray = [
  {
    ...PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS.objects.DETAILS,
    component: ByDetails,
    active: true
  },
  {
    ...PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS.objects.ACCOUNT_TITLES,
    component: ByAccountTitles
  }
];

const Index = props => {
  const {
    data,
    processing,
    history,
    changeState,
    user,
    confirmData,
    showConfirm,
    showReasonModal,
    closeConfirm,
    match
  } = props;

  useEffect(() => {
    if (
      data.logs.length > 0 &&
      parseInt(match.params.id) === parseInt(data.id)
    ) {
      const firstSignature = data.logs[0];
      if (
        firstSignature.type === STATE_ENUM.IMPREST_RETURN &&
        firstSignature.target_user_ids &&
        firstSignature.target_user_ids.includes(user.id)
      ) {
        setConfirmDataToDisplay(
          REJECT_OR_RETURN_WARNING_TEXT(firstSignature),
          "",
          "warning"
        );
      }
    }
  }, [data.logs]);

  const setConfirmDataToDisplay = (message, action, confirmOrWarningType) => {
    showConfirm({
      show: true,
      message: message,
      action: action,
      confirmOrWarningType: confirmOrWarningType
    });
  };
  const confirmAcceptHandler = () => {
    const sendFlag = data.send_flag;

    switch (confirmData.action) {
      case PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_SHARE:
        let nextConfirmAction = "";
        if (sendFlag) {
          nextConfirmAction = PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_SURE;
        } else {
          nextConfirmAction = PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_ORDER;
        }
        setConfirmDataToDisplay(
          CUSTODIAN_CONFIRM_FOR_CHANGE_STATE(nextConfirmAction),
          nextConfirmAction,
          "danger"
        );
        break;
      case PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_SURE:
        changeState(data.id, CUSTODIAN_CHANGE_STATE_MODES.SEND);
        break;
      case PETTY_CASH_CONFIRM_ACCEPT_ACTION.RETURN_SURE:
        changeState(data.id, CUSTODIAN_CHANGE_STATE_MODES.RETURN);
        break;
    }
  };
  const sendOrReturnPettyCash = () => {
    const isOwner = localStorage.getItem(USER_IS_OWNER) === "true";
    const sendFlag = data.send_flag;
    const state = data.state;
    let buttonText = "";

    let confirmAction = "";
    let confirmMessage = "";
    let onClick;
    let confirmOrWarningType = "danger"; //default: confirm

    switch (state) {
      case FINAL_EDITED:
        buttonText = "ارسال تنخواه";
        if (!sendFlag) {
          confirmAction = PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_ORDER;
          confirmOrWarningType = "warning";
        } else {
          if (isOwner) {
            confirmAction = PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_SHARE;
          } else {
            confirmAction = PETTY_CASH_CONFIRM_ACCEPT_ACTION.SEND_SURE;
          }
        }
        break;
      case FINAL_EDITED_SENT:
        if (isOwner) {
          buttonText = "بازگشت تنخواه ارسالی";
          confirmAction = PETTY_CASH_CONFIRM_ACCEPT_ACTION.RETURN_SURE;
        } else {
          buttonText = "درخواست بازگشت تنخواه";
          onClick = () => {
            showReasonModal({
              title: "درخواست بازگشت تنخواه ارسالی",
              reasonObject: REASON.REQUEST_FOR_RETURN_PETTY_CASH
            });
          };
        }
        break;
    }
    confirmMessage = CUSTODIAN_CONFIRM_FOR_CHANGE_STATE(confirmAction);

    return (
      <ButtonsBox>
        <div className="container">
          <div className="box">
            <div className="right-part">
              {buttonText && (
                <Button
                  btn="primary"
                  onClick={() => {
                    if (onClick) {
                      onClick();
                    } else {
                      setConfirmDataToDisplay(
                        confirmMessage,
                        confirmAction,
                        confirmOrWarningType
                      );
                    }
                  }}
                >
                  {buttonText}
                </Button>
              )}
            </div>
          </div>
        </div>
      </ButtonsBox>
    );
  };

  const setActive = id => {
    let searchParam = new URLSearchParams(history.location.search);

    if (parseInt(searchParam.get(TYPE)) !== parseInt(id)) {
      let search = `?`;
      let i = 0;
      if (searchParam.has(TYPE)) {
        searchParam.set(TYPE, id);
      }
      for (const [key, value] of searchParam.entries()) {
        search += `${key}=${value}&`;
        i += 1;
      }
      if (!searchParam.has(TYPE)) {
        search += `${TYPE}=${id}`;
      }
      history.replace({ search: `${search}` });
    }
  };

  const pettyCashRemain =
    parseInt(data.opening_balance) +
    parseInt(data.receives_sum) -
    parseInt(data.payments_sum);
  if (!isEmpty(data)) {
    return (
      <React.Fragment>
        <ReasonModal
          processing={processing}
          submitReason={payLoad =>
            changeState(
              data.id,
              CUSTODIAN_CHANGE_STATE_MODES.REQUEST_RETURN,
              payLoad
            )
          }
        />
        <PrintInfo />
        <Confirm
          show={confirmData.show}
          loading={processing}
          content={{
            type: confirmData.confirmOrWarningType,
            icon: "icon mapsa-notification",
            message: confirmData.message,
            acceptButtonText:
              confirmData.confirmOrWarningType === "warning"
                ? ""
                : CONFIRM_OK_BUTTON_TEXT,
            rejectButtonText:
              confirmData.confirmOrWarningType === "warning"
                ? WARNING_SINGLE_BUTTON_TEXT
                : CONFIRM_REJECT_BUTTON_TEXT
          }}
          acceptHandler={() => confirmAcceptHandler()}
          rejectHandler={closeConfirm}
          close={closeConfirm}
        />
        {data.state && (
          <FieldContainer largeFont>
            <span className="label">وضعیت تنخواه</span>
            <span className="value">
              {CustodianImprestStateText[data.state]}
            </span>
          </FieldContainer>
        )}
        {data.start_date && data.end_date && (
          <FieldContainer group>
            <div className="group">
              <span className="label">تاریخ شروع</span>
              <span className="value">
                {formatDateInNumbers(data.start_date)}
              </span>
            </div>

            <div className="group">
              <span className="label">تاریخ پایان</span>
              <span className="value">
                {formatDateInNumbers(data.end_date)}
              </span>
            </div>
          </FieldContainer>
        )}
        <FieldContainer group largeFont>
          <div className="group">
            <span className="label">
              مانده از تنخواه قبلی{" "}
              <span className="unit">({localStorage.getItem(CURRENCY)})</span>
            </span>
            <span className="value">
              <span className={`num ${data.opening_balance < 0 ? "red" : ""}`}>
                {data.opening_balance.toLocaleString("fa")}
              </span>
            </span>
          </div>

          <div className="group">
            <span className="label">
              جمع دریافت‌ها{" "}
              <span className="unit">({localStorage.getItem(CURRENCY)})</span>
            </span>
            <span className="value">
              {parseInt(data.receives_sum).toLocaleString("fa")}
            </span>
          </div>

          <div className="group">
            <span className="label">
              جمع پرداخت‌ها{" "}
              <span className="unit">({localStorage.getItem(CURRENCY)})</span>
            </span>
            <span className="value">
              {parseInt(data.payments_sum).toLocaleString("fa")}
            </span>
          </div>
        </FieldContainer>

        <FieldContainer group>
          <div className="group">
            <span className="label">
              مانده این تنخواه{" "}
              <span className="unit">({localStorage.getItem(CURRENCY)})</span>
            </span>
            <span className="value">
              <ColoredBox color={pettyCashRemain < 0 ? "danger" : "success"}>
                <span className="num">
                  {pettyCashRemain.toLocaleString("fa")}
                </span>
              </ColoredBox>
            </span>
          </div>
          {pettyCashRemain < 0 && (
            <div className="group">
              <div className="notice">
                توجه: جمع پرداخت‌های این تنخواه از جمع دریافت‌ها بیشتر شده است و
                این اضافه پرداختی به مانده تنخواه بعدی شما انتقال می‌یابد.
              </div>
            </div>
          )}
        </FieldContainer>
        {data.description && (
          <FieldContainer>
            <span className="label top">توضیحات گزارش</span>
            <span
              className="value"
              dangerouslySetInnerHTML={{
                __html: makeSafe(data.description.split("\n").join("<br/>"))
              }}
            />
          </FieldContainer>
        )}
        <LogSection logs={data.logs} />
        <BudgetSection budget={data.match_budget} />
        <TabWrapper>
          <Tab
            title="نمایش بر اساس:"
            topMargin={64}
            panes={PanesArray}
            active={
              PanesArray.filter(tabs => tabs.active === true).map(
                tab => tab.id
              )[0]
            }
            isInMiddleOfContent
            setActive={data => setActive(data)}
          />
        </TabWrapper>
        {sendOrReturnPettyCash()}
      </React.Fragment>
    );
  } else {
    return <React.Fragment />;
  }
};

const mapStateToProps = store => {
  return {
    initData: store.Init.data,
    user: store.User.data,
    processing: store.PettyCashierPettyCash.changeStateProcessing,
    confirmData: store.PettyCash.confirm
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeState: (id, func, data) =>
      dispatch(PettyCashierPettyCashAction.changeState(id, func, data)),
    showReasonModal: data => {
      dispatch(PettyCashAction.reasonModalData(data));
    },
    showConfirm: data => {
      dispatch(PettyCashAction.confirmData(data));
    },
    closeConfirm: () => {
      dispatch(PettyCashAction.closeConfirm());
    }
  };
};

const MainComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));

const getTitle = (
  data,
  newParam = `
    گزارش تنخواه شماره ${data.imprest_number}
    `
) => {
  return newParam;
};

const returnPrintInfoValues = data => {
  let values = {};
  if (data) {
    values = {
      id: data.id,
      [START_DATE]: data[START_DATE],
      [END_DATE]: data[END_DATE],
      [DESCRIPTION]: data[DESCRIPTION]
    };
  }
  return values;
};

export default SummaryForm(
  MainComponent,
  {
    getTitle: getTitle,
    type: SummaryTypes.PETTY_CASH,
    reducer_type: REDUCER_NAMES.SUMMARY.PETTY_CASHIER.PETTY_CASH,
    type_name: SummaryTypeNames[SummaryTypes.PETTY_CASH],
    getItem: PettyCashierPettyCashAction.getRequest,
    editHandleClick: id => `${PETTY_CASH_PETTY_CASHIER}/${id}`,
    editPrintInfoClick: data =>
      PettyCashierPettyCashAction.printInfoModalData(
        returnPrintInfoValues(data)
      ),
    removeHandleClick: PettyCashierPettyCashAction.remove,
    getFileHandleClick: getFileHandleClick,
    hasEditConfirm: true,
    messages: {
      defaultDeleteConfirm: () =>
        "آیا از لغو گزارش تنخواه اطمینان دارید؟ با لغو گزارش‌های تنخواه، تراکنش‌های گزارش شده در آن حذف نخواهند شد و تنها گزارش تنخواه مربوطه لغو می‌شود.",
      editConfirm: () =>
        `در صورت ویرایش این تنخواه، مانده تنخواه‌های بعد از آن تغییر خواهند کرد.`
    }
  }
  // TransactionsItemComponent
);
